export const API_URL = "https://lkbe.frprf.ru/ws/restapi/v1/";
export const AUTH_URL = "https://lkbe.frprf.ru/";
export const IS_DEV_MODE = false;
// Показывать форму авторизации по пути /DAIT (на проде отключена — редирект на главную)
export const IS_AUTH_FORM_ENABLED = false;

export const BUTGET_URL = "https://budget.frprf.ru/";
